import { useEffect, useState, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate, useParams } from 'react-router';

import { Card, CardActionArea, CardMedia, CardContent, Typography, Container, Grid, CardActions, Button, Grow, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Box, Skeleton, Stack, Divider, FormControl, ButtonGroup } from '@mui/material'

import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { Header } from '../../components/Header';

import { CardEmpty } from '../../components/CardEmpty';

import CircularWithValueLabel from '../../components/CircularWithValueLabel';

import { ObtenerTipoServiciosUnidad } from '../../connections/catalogos/TipoServicioConnection';
import { AgregarServicio, ImprimirTicket, ReenviarWhatsApp } from '../../connections/comun/ServicioConnection';

import { TipoServicioUnidadProps } from '../../interfaces/catalogos/TipoServicioInterface';
import { defaultServicio, ServicioProps } from '../../interfaces/comun/ServicioInterface';

export const ServiciosPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { id } = useParams();

    const { phoneNumber } = useSelector( ( state: RootState ) => state.whatsAppNotification );

    const [openConfirmacion, setOpenConfirmacion] = useState( false );
    const [openAcuse, setOpenAcuse] = useState( false );

    const [loading, setLoading] = useState( false );

    const [unidad, setUnidad] = useState( '' );
    const [servicio, setServicio] = useState( '' );

    const [tipoServicio, setTipoServicio] = useState(0);
    const [servicios, setServicios] = useState<TipoServicioUnidadProps[]>( [] );

    const [load, setLoad] = useState( true );

    const [turno, setTurno] = useState<ServicioProps>( defaultServicio );

    const [numeroTurno, setNumeroTurno] = useState( '' );
    const [codigoAcceso, setCodigoAcceso] = useState( '' );

    const [timer, setTimer] = useState( 0 );
    const [timerWhatsApp, setTimerWhatsApp] = useState( 0 );

    const [atencionUrgente, setAtencionUrgente] = useState( false );

    const audioRef = useRef<HTMLAudioElement>(new Audio( process.env.PUBLIC_URL + '/assets/click.wav' ));

    const sound = () => {

        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current.play();

    }

    const handleClick = ( idTipoServicio: number, descripcion: string ) => {

        if ( audioRef.current ) {          

            sound();            
            setTipoServicio( idTipoServicio );
            setServicio( descripcion );
            setOpenConfirmacion( true );

        }

    }

    const goTo = ( path: string ) => {

        if ( audioRef.current ) {            
            sound();
            navigate( path );
        }

    };

    const handleClosed = () => {

        if ( audioRef.current ) {            

            sound();
            setOpenConfirmacion( false );
            setOpenAcuse( false );

        }

    };

    const handleAgregarServicio = async () => {

        if ( audioRef.current ) {
            sound();
        }

        setLoading( true );

        await AgregarServicio({ idTipoServicio: tipoServicio, telefonoCelular: phoneNumber, atencionUrgente }).then( resp => {

            const { success, message, idServicio, numeroTurno, codigoAcceso } = resp;

            if ( success ) {

                setTimeout(() => {

                    setTurno({ idServicio, numeroTurno, codigoAcceso });

                    setNumeroTurno( numeroTurno );
                    setCodigoAcceso( codigoAcceso );

                    setOpenConfirmacion( false );

                    setOpenAcuse( true );
                    setLoading( false );

                }, 700);

            }
            else {

                setTimeout(() => {

                    setLoading( false );

                    dispatch( openSnackbar({ message: message, variant: 'error' }));  

                }, 700);

            }

        });

    }

    const handleImprimeTicket = async () => {

        if ( audioRef.current ) {            
            sound();
        }

        await ImprimirTicket({ idServicio: turno.idServicio }).then(resp => {

            const { success } = resp;

            if (success) {
                setTimer( 10 );
            }

        });

    }

    const handleReenviarWhatsApp = async () => {

        if ( audioRef.current ) {            
            sound();
        }

        await ReenviarWhatsApp({ idServicio: turno.idServicio }).then( resp => {

            const { success, message } = resp;

            if ( success ) {
                setTimerWhatsApp( 10 );
            }
            else {
                dispatch( openSnackbar({ message: message, variant: 'error' }));  
            }

        });

    }

    const redirect = () => {

        setTimer( 0 );
        setTimerWhatsApp( 0 );
        setOpenAcuse( false );
        navigate( '/' );

    }

    useEffect(() => {

        async function obtener() {

            setLoad(true);

            await ObtenerTipoServiciosUnidad(parseInt(id ?? '0')).then(resp => {

                setUnidad(resp.unidad);
                setServicios(resp.servicios);
                setLoad(false);

            });

        }

        if (id) {
            obtener();
        }


    }, [id])

    useEffect(() => {

        let timeout: NodeJS.Timeout;

        if ( timer > 0 ) {

            timeout = setTimeout(() => {

                setTimer((time) => time - 1);

            }, 1000);

        }

        return () => clearTimeout( timeout )

    }, [ timer ])

    useEffect(() => {

        let timeout: NodeJS.Timeout;

        if ( timerWhatsApp > 0 ) {

            timeout = setTimeout(() => {

                setTimerWhatsApp((time) => time - 1);

            }, 1000);

        }

        return () => clearTimeout( timeout )

    }, [ timerWhatsApp ])

    useEffect(() => {
      
        if( openConfirmacion ){
            setAtencionUrgente( false );
        }

    }, [ openConfirmacion ])    

    return (

        <>

            <Header />

            <Container maxWidth='xl' sx={{ pt: 1, pb: 4 }}>

                {
                    load
                    ?
                        <Skeleton animation='wave' height={120} width='100%' sx={{ mt: -2 }} />
                    :
                        <Typography variant='h3' color='black'>
                            { unidad }
                        </Typography>
                }

                <Grid container spacing={3} my={3}>

                    <Grid size={12} textAlign={'end'}>

                        <Button
                            color='primary'
                            variant='contained'
                            sx={{ textTransform: 'none', width: 300, height: 45 }}
                            startIcon={<UndoOutlinedIcon />}
                            onClick={ () => { goTo('/'); }}
                            disabled={load}
                        >
                            Regresar
                        </Button>

                    </Grid>

                    {
                        load
                        ?
                            <>

                                <CardEmpty />

                                <CardEmpty />

                                <CardEmpty />

                                <CardEmpty />

                            </>
                        :
                            <>

                                {
                                    servicios
                                    .map(({ idTipoServicio, descripcion, imagen }, index) => (

                                        <Grid key={index} size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>

                                            <Grow
                                                in={true}
                                                style={{ transformOrigin: '0 0 0' }}
                                                {...(true ? { timeout: 1000 } : {})}
                                            >

                                                <Card>

                                                    <CardActionArea onClick={ () => handleClick( idTipoServicio, descripcion ) }>

                                                        <CardMedia
                                                            component='img'
                                                            height='240'
                                                            image={
                                                                imagen
                                                                ?
                                                                    imagen
                                                                :
                                                                    process.env.PUBLIC_URL + '/assets/sin-imagen.png'
                                                            }
                                                            alt={'image' + index}
                                                            sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                                        />

                                                        <CardContent sx={{ height: 50 }}>

                                                            <Typography gutterBottom fontSize={16} fontWeight={'500'} variant='body1' component='div'>
                                                                {descripcion}
                                                            </Typography>

                                                        </CardContent>

                                                    </CardActionArea>

                                                    <CardActions sx={{ textAlign: 'end' }}>

                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            onClick={ () => handleClick( idTipoServicio, descripcion ) }
                                                        >                                                                
                                                            Seleccionar opción                                                                
                                                        </Button>

                                                    </CardActions>

                                                </Card>

                                            </Grow>

                                        </Grid>
                                    ))
                                }

                            </>
                    }

                </Grid>

                <Dialog
                    fullWidth
                    disableEscapeKeyDown
                    maxWidth='sm'
                    open={ openConfirmacion }
                    onClose={ () => {} }
                >
                    <DialogTitle fontSize={24}>
                        Confirmación
                    </DialogTitle>

                    <DialogContent>

                        <Stack spacing={3}>

                            <Stack spacing={0.5}>

                                <Typography color="text.secondary" variant='subtitle2'>
                                    Unidad
                                </Typography>

                                <Typography fontWeight={600}>
                                    { unidad }
                                </Typography>

                            </Stack>

                            <Stack spacing={0.5}>

                                <Typography color="text.secondary" variant='subtitle2'>
                                    Tipo de servicio
                                </Typography>
                            
                                <Typography fontWeight={600}>
                                    { servicio }
                                </Typography>

                            </Stack>                            

                            <Stack spacing={0.5}>

                                <Typography fontWeight={600}>
                                    ¿El servicio requiere atención urgente?
                                </Typography>

                                <Typography color="text.secondary" variant='subtitle2'>
                                    (Discapacidad, adultos mayores, embarazo u otros casos)
                                </Typography>

                                <FormControl>
                                  
                                    <ButtonGroup variant="outlined" fullWidth sx={{ mt: 1 }}>

                                        <Button variant={ atencionUrgente ? 'contained' : 'outlined'} onClick={ () => setAtencionUrgente( true ) }>
                                            Si
                                        </Button>

                                        <Button variant={ !atencionUrgente ? 'contained' : 'outlined'} onClick={ () => setAtencionUrgente( false ) }>
                                            No
                                        </Button>

                                    </ButtonGroup>

                                </FormControl>

                            </Stack>

                            <Divider sx={{ my: 1 }} />

                            <Typography fontSize={16} textAlign="center" fontWeight={600}>
                                ¿Desea confirmar y finalizar el servicio?
                            </Typography>

                        </Stack>                   

                    </DialogContent>

                    <DialogActions>

                        <Button
                            color='secondary'
                            onClick={ handleClosed }
                            disabled={loading}
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={ handleAgregarServicio }
                            variant='contained'
                            loading={loading}
                        >
                            Aceptar
                        </Button>

                    </DialogActions>


                </Dialog>

                <Dialog
                    disableEscapeKeyDown
                    open={ openAcuse }
                    onClose={ () => {} }
                    maxWidth={ 'md' }
                >
                    <IconButton                        
                        onClick={ () => { handleClosed(); navigate( '/' ); }}
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <CloseIcon />
                    </IconButton>

                    <DialogContent sx={{ width: 320 }}>

                        <Box>

                            <Box textAlign={'center'} mt={3}>

                                <img
                                    alt='imagen-qr'
                                    src={codigoAcceso}
                                    style={{ width: 220, height: 220 }}
                                />

                            </Box>

                            {
                                numeroTurno
                                &&      
                                    <Typography variant='body2' textAlign={'center'} fontSize={16} mt={1}>
                                        Número de turno
                                    </Typography>                                
                            }

                            <Typography variant='body2' textAlign={'center'} fontSize={26} fontWeight={'bold'} mb={3}>
                                { numeroTurno }
                            </Typography>

                        </Box>

                        <Button
                            fullWidth
                            variant='contained'
                            onClick={ handleImprimeTicket }
                            disabled={ timer !== 0 }
                        >
                            {
                                ( timer !== 0 )
                                ?
                                    `Reintentar en ${timer} `
                                :
                                    'Imprimir ticket'
                            }
                        </Button>

                        {
                            phoneNumber
                            &&
                                <Button
                                    fullWidth
                                    color='success'
                                    variant='contained'
                                    onClick={ handleReenviarWhatsApp }
                                    disabled={ timerWhatsApp !== 0 }
                                    sx={{ mt: 3 }}
                                    startIcon={
                                        <WhatsAppIcon
                                            sx={{
                                                fontSize: 18,
                                                "&.MuiSvgIcon-root": {
                                                    fontSize: 18,
                                                },
                                            }}
                                        />
                                    }
                                >
                                    {
                                        ( timerWhatsApp !== 0 )
                                        ?
                                            `Reintentar en ${ timerWhatsApp } `
                                        :
                                            'Reenviar por WhatsAppp'
                                    }
                                </Button>
                        }

                    </DialogContent>

                    <DialogActions sx={{ textAlign: 'center' }}>
                        <CircularWithValueLabel callback={ redirect } />
                    </DialogActions>

                </Dialog>

            </Container>

        </>

    )
}

